import { BusStop } from '@/types/logs'
import { parseLocationStopValue } from './location'

export const checkIsToStopValid = (allStops: BusStop[], from: string, to: string): boolean => {
    const selectedFromIndex = allStops.findIndex((item) => {
        const { stopNumber, direction } = parseLocationStopValue(from)

        return item.stopNumber === stopNumber && item.direction === direction
    })
    const selectedToIndex = allStops.findIndex((item) => {
        const { stopNumber, direction } = parseLocationStopValue(to)

        return item.stopNumber === stopNumber && item.direction === direction
    })
    const fromStop = allStops[selectedFromIndex]
    const toStop = allStops[selectedToIndex]

    if (fromStop.direction !== toStop.direction) {
        return true
    }

    return selectedFromIndex < selectedToIndex
}
